import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SideNav from './SideNav';
import { Menu, X } from 'lucide-react';
import { 
  LayoutContainer, 
  ContentContainer, 
  MobileNavToggle, 
  Overlay 
} from './MainLayout.styles';

const MainLayout = ({ children, userRole, toggleTheme, currentTheme }) => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const location = useLocation();

  // When the route changes, automatically close the mobile nav
  useEffect(() => {
    setIsNavOpen(false);
  }, [location]);

  return (
    <LayoutContainer>
      <MobileNavToggle onClick={() => setIsNavOpen(!isNavOpen)}>
        {isNavOpen ? <X size={24} /> : <Menu size={24} />}
      </MobileNavToggle>
      
      <Overlay $isOpen={isNavOpen} onClick={() => setIsNavOpen(false)} />

      <SideNav 
        userRole={userRole} 
        isOpen={isNavOpen} // Correctly pass isOpen
        toggleTheme={toggleTheme} 
        currentTheme={currentTheme} 
      />
      
      {/* This now simply renders the page component passed from App.js */}
      <ContentContainer $isNavOpen={isNavOpen}>
        {children}
      </ContentContainer>
    </LayoutContainer>
  );
};

export default MainLayout;